import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DefaultLocalStockService } from '@asm/features/sync/services/stock/default-local-stock.service';

/**
 * Handler offline para endpoints de estoque.
 * Cobre: GET /stock/calculate, GET /stock/details/, POST /stock/allocate
 */
@Injectable({ providedIn: 'root' })
export class StockOfflineHandler {
  private readonly localStockService = inject(DefaultLocalStockService);

  canHandle(req: HttpRequest<unknown>): boolean {
    const { url, method } = req;
    return (
      (method === 'GET' && (url.includes('/stock/calculate') || url.includes('/stock/details/'))) ||
      (method === 'POST' && url.includes('/stock/allocate'))
    );
  }

  async handle(req: HttpRequest<unknown>): Promise<HttpResponse<unknown>> {
    const { url, method } = req;

    if (method === 'GET' && url.includes('/stock/calculate')) {
      const productCode = req.params.get('product') ?? '';
      const warehouseCode = req.params.get('warehouse') ?? '';
      const available = await this.localStockService.getImmediateStockAvailable(productCode, warehouseCode);
      return new HttpResponse({
        status: 200,
        body: { available: available > 0, availableStock: available },
      });
    }

    if (method === 'GET' && url.includes('/stock/details/')) {
      const pathParts = url.split('/stock/details/')[1].split('?')[0].split('/');
      const distributionChannel = req.params.get('distributionChannel') ?? '20';
      const b2bUnitId = req.headers.get('x-b2bunit-id') ?? '';
      const requesterId = req.headers.get('x-b2bcustomer-id') ?? '';
      const details = await this.localStockService.getStockDetails(
        pathParts[0] ?? '',
        pathParts[1] ?? '',
        b2bUnitId,
        distributionChannel,
        requesterId,
      );
      return new HttpResponse({ status: 200, body: details });
    }

    if (method === 'POST' && url.includes('/stock/allocate')) {
      const body = (req.body ?? {}) as any;
      const channel = body.channel ?? '20';
      const b2bUnitId = req.headers.get('x-b2bunit-id') ?? '';
      const requesterId = req.headers.get('x-b2bcustomer-id') ?? '';
      const result =
        channel === '10'
          ? await this.localStockService.allocateForFrigorifico(
              body.productCode,
              body.quantity,
              body.warehouseCode,
              b2bUnitId,
              requesterId,
            )
          : await this.localStockService.allocateForDistribution(body.productCode, body.quantity, body.warehouseCode);
      return new HttpResponse({ status: 200, body: result });
    }

    throw new Error(`[StockOfflineHandler] Rota não mapeada: ${method} ${url}`);
  }
}
